import { configureStore } from '@reduxjs/toolkit';
import watchlistReducer from './watchlist';
import authReducer from './auth';
import securityReducer from './security';
import registerReducer from "./registerSlice";
import watchlistTableSearchItemReducer from "./watchlistTableSearchItemSlice";
import profileReducer from "./profileSlice";
import portfolioReducer from './portfolioSlice';
import selectedItemReducer from './selectedItemSlice';
import fixedColumnsReducer from './fixedColumnsStore';

const store = configureStore({
  reducer: {
    auth: authReducer,
    watchlist: watchlistReducer,
    security: securityReducer,
    register: registerReducer,
    watchlistTableSearchItem: watchlistTableSearchItemReducer,
    profile: profileReducer,
    portfolio: portfolioReducer,
    selectedItem: selectedItemReducer,
    fixedColumns: fixedColumnsReducer,
  },
});

export default store;
